// Politique de confidentialité (Loi 25) : fragment HTML du prototype accepté.
import { Meta, Title } from '@solidjs/meta';
import html from './fragments/confidentialite.html?raw';

export default function Confidentialite() {
  return (
    <>
      <Title>Politique de confidentialité (Loi 25) — TG3R</Title>
      <Meta
        name="description"
        content="Comment TG3R recueille, utilise, conserve et protège vos renseignements personnels, conformément à la Loi 25 du Québec. Vos droits et la personne responsable à contacter."
      />
      <div innerHTML={html} />
    </>
  );
}
